export default __webpack_public_path__ + "static/media/Doppelt Verkettet.b69a81f3.jpg";